import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import { StoreModule } from './storeModule/storeModule'

export default new Vuex.Store(StoreModule);
